export default{
	computed:{
		hasErrors(){
			return this.errorMessage !== null;
		},
	},

	data:() => ({
		errors:{},
		errorMessage:null,
	}),
	methods:{
		resetErrors(){
			this.errors = {};
			this.errorMessage = null;
		},
		setErrors(errors){
			this.resetErrors();

			if(errors.response.data.hasOwnProperty('errors')){
				this.errors = errors.response.data.errors;
			}
			if(errors.response.data.hasOwnProperty('message')){
				this.errorMessage = errors.response.data.message;
				if(this.errorMessage === ''){
					this.errorMessage = 'There has been a problem with your request';
				}	
			}
		}
	}

}